export enum ComponentId {
  PERPETRATOR_REGISTRATION_NUMBER = "registrationNumber",
  PERPETRATOR_OC_NUMBER = "ocNumber",
  PERPETRATOR_NAME = "name",
  PERPETRATOR_SURNAME = "surname",
  PERPETRATOR_PHONE = "phone",
  PERPETRATOR_EMAIL = "email",
}
